import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  TextField,
  Grid,
  Checkbox,
  FormControlLabel,
  Button,
  Box,
  MenuItem
} from "@mui/material";
import { useSnackbar } from "src/components/snackbar/useSnackbar";
import CircularProgress from "@mui/material/CircularProgress";
import { get, put } from "src/services/httpClient.service";

const Updatevendor = () => {
  const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;
  const { id } = useParams();
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

  const [form, setForm] = useState<any>(null);

  //validations
  const [errors, setErrors] = useState({
  vendorMail: "",
  vendorName: "",
  vendorContactNo: "",
  streamEngine: "",
  streamEngineUrl: "",
  channelPort: "",
  apiPort: "",
  drmUrl: "",
  drmUserName: "",
  drmLicenseKey: "",
  //galleryPort: "",
  //drmUrl: "",
  //drmUserName: "",
  //drmLicenseKey: "",
  //fileUploadUrl: "",
  //fileUploadPort: "",
  status: "",
  mediaServerUrl: "",
  mediaServerChannelPort: "",
  publicUrl: "",
  publicChannelPort: "",
  mobilePackageName: "",
  tvPackageName: "",
});

//validations forms

const validateForm = () => {
  let tempErrors: any = {};

  let isValid = true;

  // Required fields
  const requiredFields = [
    "vendorMail",
    "vendorName",
    "vendorContactNo",
    "streamEngine",
    "streamEngineUrl",
    "channelPort",
    "apiPort",
    //"drmUrl",
    //"drmUserName",
    //"drmLicenseKey",
    //"galleryPort",
    "status",
     //"drmUrl",
  //"drmUserName",
  //"drmLicenseKey",
  //"fileUploadUrl",
  //"fileUploadPort",
  "mediaServerUrl",
  "mediaServerChannelPort",
  "publicUrl",
  "publicChannelPort",
  "mobilePackageName",
  "tvPackageName",

  ];

  requiredFields.forEach((field) => {
    if (!form[field]?.trim()) {
      tempErrors[field] = `${field} is required`;
      isValid = false;
    }
  });

  // Email validation
  if (form.vendorMail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.vendorMail)) {
    tempErrors.vendorMail = "Enter a valid email";
    isValid = false;
  }

  // Phone validation (10 digits)
  if (form.vendorContactNo && !/^\d{10}$/.test(form.vendorContactNo)) {
    tempErrors.vendorContactNo = "Contact number must be 10 digits";
    isValid = false;
  }

  setErrors(tempErrors);
  return isValid;
};


  useEffect(() => {
    const fetchVendor = async () => {
      try {
        const response = await get(`${API_BASE_URL}/api/vendors`);

        const selectedVendor = response.find(
          (v: any) => String(v.vendorId) === String(id)
        );

        setForm(selectedVendor); // Prefill form
      } catch (error) {
        console.error("Failed to fetch vendor:", error);
      }
    };

    fetchVendor();
  }, [id]);

  const handleChange = (e: any) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCheck = (e: any) => {
    setForm({ ...form, [e.target.name]: e.target.checked });
  };

  

  const handleUpdate = async () => {
    if (!validateForm()) return; 
    try {

        setLoading(true);
      const res = await put(`${API_BASE_URL}/api/vendors/${id}`, form);
      console.log('updatetes',res)
       //showSnackbar("Vendor updated successfully", "success");
      if (res.status === "OK") {
        showSnackbar("Vendor updated successfully", "success");
        navigate("/vendors/vendorDetails");
      } else {
        showSnackbar(res.message || "Update failed", "error");
      }
    } catch (err: any) {
      console.error(err);
      showSnackbar(err?.message || "Error updating vendor", "error");
    }finally {
    setLoading(false);  // 🔥 important to avoid memory leak warning
  }
  };

  if (!form) return <div>Loading...</div>;

  return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={2}>
        {/* TEXT INPUT FIELDS (same as Addvendor) */}
        {[
          "vendorMail",
          "vendorName",
          "vendorContactNo",
          "streamEngine",
          "streamEngineUrl",
          "channelPort",
          "apiPort",
          "drmUrl",
          "drmUserName",
          "drmLicenseKey",
          //"galleryPort",
          //"drmUrl",
          //"drmUserName",
          //"drmLicenseKey",
          //"fileUploadUrl",
          //"fileUploadPort",
          "mediaServerUrl",
          "mediaServerChannelPort",
          "publicUrl",
          "publicChannelPort",
          "mobilePackageName",
          "tvPackageName",
        ].map((field) => (
          <Grid item xs={12} sm={6} key={field}>

            {field === "streamEngine" ? (
              <TextField
                select
                fullWidth
                label="Stream Engine Type"
                name={field}
                value={(form as any)[field]}
                onChange={handleChange}
                error={!!errors[field]}
                helperText={errors[field]}
              >
                <MenuItem value="INTERNAL">INTERNAL</MenuItem>
                <MenuItem value="EXTERNAL">EXTERNAL</MenuItem>
              </TextField>
            ) : (
              <TextField
                fullWidth
                label={field}
                name={field}
                value={(form as any)[field]}
                onChange={handleChange}
                error={!!errors[field]}
                helperText={errors[field]}
              />
            )}

          </Grid>
        ))}

        {/* STATUS DROPDOWN */}
        <Grid item xs={12} sm={6}>
          <TextField
            select
            fullWidth
            label="Status"
            name="status"
            value={form.status || ""}
            onChange={handleChange}
            SelectProps={{ native: true }}
           
          >
            <option value="">Select Status</option>
            <option value="ACTIVE">ACTIVE</option>
            <option value="INACTIVE">INACTIVE</option>
          </TextField>
        </Grid>

        {/* CHECKBOX FIELDS (same as Addvendor) */}
        {[
          "hasDrmAccess",
          //"enableCommonGallery",
          "enableMediaServer",
          "enableCommonMediaServer",
          "enablePublicUrl",
          "enableCommonPublicUrl"
        ].map((field) => (
          <Grid item xs={12} sm={6} key={field}>
            <FormControlLabel
              control={
                <Checkbox
                  name={field}
                  checked={form[field] || false}
                  onChange={handleCheck}
                />
              }
              label={field}
            />
          </Grid>
        ))}

        {/* UPDATE BUTTON */}
        <Grid item xs={12} >
            <Box sx={{display:'flex',gap:'10px',justifyContent: "flex-end"}}>
                
          <Button
            variant="contained"
            onClick={handleUpdate}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} /> : null}
          >
            {loading ? "updating..." : "Update Vendor"}
          </Button>
          <Button variant="contained" onClick={()=>navigate('/vendors/vendorDetails')}>
            cancel
          </Button>
            </Box>
          
        </Grid>
      </Grid>
    </Box>
  );
};

export default Updatevendor;
